import React, { useState, useEffect } from 'react';
import { Progress, Box } from '@landr/maestro';
import { css } from '@landr/styled-system/css';

const loaderStyles = css({
    flex: '1 0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
});

interface LoaderProps {
    delay?: number;
    onLoad?: () => void;
    onUnload?: () => void;
}

const Loader: React.FC<LoaderProps> = ({ delay = 500, onLoad, onUnload }) => {
    const [isShowing, setIsShowing] = useState(false);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsShowing(true);
        }, delay);

        return () => clearTimeout(timeoutId);
    }, [delay]);

    useEffect(() => {
        onLoad?.();
        return () => onUnload?.();
    }, [onLoad, onUnload]);

    return (
        <Box role="status" className={loaderStyles}>
            {isShowing && <Progress size="lg" />}
        </Box>
    );
};

export default Loader;
